import OrganizationUser from "@/pages/contactpersonen/$organizationUserId/gegevens/OrganizationUser"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contactpersonen/$organizationUserId/gegevens/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { organizationUserId } = useParams({
    from: "/beheer/contactpersonen/$organizationUserId",
  })

  return <OrganizationUser organizationUserId={Number(organizationUserId)} />
}
